export const SET_TRANSLATED_VALUE = 'forms/SET_TRANSLATED_VALUE';

export const setTranslatedValue = (form, field, text) => ({
    type: `${SET_TRANSLATED_VALUE}[${form}]`,
    payload: { text },
    meta: { form, field },
});
